<template>
  <div class="create-employe">
    <el-backtop target=".create-employe"></el-backtop>
    <header-top showBack></header-top>
    <div class="header-title show-back">分销人员</div>
    <div class="basic-info">
      <el-form
        label-position="left"
        label-width="6rem"
        ref="employeForm"
        :rules="employeRules"
        :model="employe"
      >
        <div class="basic-item">
          <div class="basic-item-title">基本信息</div>
          <div class="basic-item-main">
            <div class="main-item">
              <el-form-item label="头像" class="auto-height">
                <div class="basic-head">
                  <div class="basic-head-item">
                    <img
                      src="@/assets/image/default-img.png"
                      alt="default"
                      class="default-img"
                      v-if="!photoUrl"
                    />
                    <img
                      :src="photoUrl"
                      alt="headImg"
                      class="basic-head-img"
                      v-else
                    />
                    <el-upload
                      action="https://jsonplaceholder.typicode.com/posts/"
                      :on-change="uploadChange"
                      list-type="picture"
                      :show-file-list="false"
                      :http-request="getFile"
                    >
                      <el-button class="upload-btn">{{ uploadText }}</el-button>
                    </el-upload>
                  </div>
                  <div class="form-tip">
                    注意：建议上传格式为jpg/jpeg/png且大小不超过5MB的图片
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="姓名" prop="name">
                <el-input
                  v-model="employe.name"
                  placeholder="请输入姓名"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="密码" class="auto-height" prop="password">
                <el-input
                  v-model="employe.password"
                  placeholder="请输入密码（选填，不填则为默认密码）"
                  clearable
                ></el-input>
                <div class="form-tip">
                  包含{{ passwordOptions.requireLowercase ? "小写字母" : ""
                  }}{{ passwordOptions.requireUppercase ? " 大写字母" : ""
                  }}{{ passwordOptions.requireDigit ? " 数字" : ""
                  }}{{
                    passwordOptions.requireNonAlphanumeric ? " 非字母数字" : ""
                  }}，最少{{ passwordOptions.length }}位数
                </div>
              </el-form-item>
              <el-form-item label="出生日期">
                <el-date-picker
                  align="center"
                  v-model="employe.birthday"
                  type="date"
                  placeholder="请选择出生日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="婚姻状况">
                <el-select
                  v-model="employe.marriageStatus"
                  clearable
                  placeholder="请选择婚姻状况"
                >
                  <el-option
                    v-for="item in marriageOptions"
                    :key="item.option"
                    :label="item.option"
                    :value="item.option"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="籍贯">
                <el-input
                  v-model="employe.native"
                  placeholder="请输入籍贯"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <div class="main-item basic-item-right main-item-flex">
              <el-form-item label="性别">
                <el-select
                  v-model="employe.sex"
                  clearable
                  placeholder="请选择性别"
                >
                  <el-option
                    v-for="item in sexOptions"
                    :key="item.option"
                    :label="item.option"
                    :value="item.option"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="身份证号" prop="identityCard">
                <el-input
                  v-model="employe.identityCard"
                  placeholder="请输入身份证号"
                  @blur="identityCardBlur(employe.identityCard)"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="民族">
                <el-select
                  v-model="employe.nation"
                  clearable
                  placeholder="请选择民族"
                >
                  <el-option
                    v-for="item in nationOptions"
                    :key="item.option"
                    :label="item.option"
                    :value="item.option"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="政治面貌">
                <el-select
                  v-model="employe.political"
                  clearable
                  placeholder="请选择政治面貌"
                >
                  <el-option
                    v-for="item in politicalOptions"
                    :key="item.option"
                    :label="item.option"
                    :value="item.option"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="带训师">
                <el-select
                  v-model="employe.trainingTeacherGrade"
                  clearable
                  placeholder="请选择带训师等级"
                >
                  <el-option
                    v-for="item in teacherGradeOptions"
                    :key="item.option"
                    :label="item.option"
                    :value="item.option"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="招聘渠道">
                <el-select
                  v-model="employe.recruitWay"
                  clearable
                  placeholder="请选择招聘渠道"
                >
                  <el-option
                    v-for="item in recruitWayOptions"
                    :key="item.option"
                    :label="item.option"
                    :value="item.option"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="家庭住址">
                <el-input
                  v-model="employe.familyAddress"
                  placeholder="请输入家庭住址"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="现居住地">
                <el-input
                  v-model="employe.currentAddress"
                  placeholder="请输入现居住地"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="basic-item">
          <div class="basic-item-title">联系方式</div>
          <div class="basic-item-main">
            <div class="main-item">
              <el-form-item label="手机号" prop="phoneNumber">
                <el-input
                  v-model="employe.phoneNumber"
                  placeholder="请输入手机号"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="QQ账号">
                <el-input
                  v-model="employe.qq"
                  placeholder="请输入QQ账号"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="紧急联系人">
                <el-input
                  v-model="employe.contactName"
                  placeholder="请输入紧急联系人"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="与联系人关系">
                <el-input
                  v-model="employe.contactRelationship"
                  placeholder="请输入与紧急联系人关系"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <div class="main-item basic-item-right">
              <el-form-item label="微信号">
                <el-input
                  v-model="employe.wechat"
                  placeholder="请输入微信号"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="邮箱" prop="email">
                <el-input
                  v-model="employe.email"
                  placeholder="请输入邮箱"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="紧急联系电话" prop="contactPhoneNumber">
                <el-input
                  v-model="employe.contactPhoneNumber"
                  placeholder="请输入紧急联系电话"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="basic-item">
          <div class="basic-item-title">员工状态</div>
          <div class="basic-item-main">
            <div class="main-item">
              <el-form-item label="入职时间" prop="workTime">
                <el-date-picker
                  align="center"
                  v-model="employe.workTime"
                  type="date"
                  placeholder="请选择入职时间"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="状态">
                <el-select v-model="employe.status" placeholder="请选择状态">
                  <el-option value="probation" label="试用期"></el-option>
                  <el-option value="recovery" label="复岗期"></el-option>
                  <el-option value="nomail" label="正式员工"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="main-item basic-item-right">
              <el-form-item label="转正考试">
                <el-radio-group v-model="employe.hasPassedRegularWorkTest">
                  <el-radio :label="true">通过</el-radio>
                  <el-radio :label="false">未通过</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                :label="tryWorkDaysLabel"
                v-if="employe.status != 'nomail'"
              >
                <el-select
                  v-model="employe.tryWorkDays"
                  :placeholder="'请选择' + tryWorkDaysLabel"
                >
                  <el-option value="30" label="一个月"></el-option>
                  <el-option value="60" label="两个月"></el-option>
                  <el-option value="90" label="三个月"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="basic-item">
          <div class="basic-item-title">
            岗位信息
            <span class="post-symbol">*</span>
          </div>
          <el-button type="primary" @click="addPosition" class="add-position"
            >添加新岗位</el-button
          >
          <el-table
            :data="tablePosts"
            style="width: 100%"
            header-align="center"
          >
            <el-table-column prop="grade" label="职务/职级">
              <template slot-scope="scope">
                <div class="grade-box">
                  {{ scope.row.grade[0] }}/{{ scope.row.grade[1] }}
                  <div class="grade-main" v-if="scope.row.isMajor">主岗</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="organization" label="部门"></el-table-column>
            <el-table-column prop="effectiveTime" label="生效时间">
              <template slot-scope="scope">{{
                scope.row.effectiveTime | filterTime
              }}</template>
            </el-table-column>
            <el-table-column
              prop="more"
              label="备注"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">{{
                scope.row.more ? scope.row.more : "—"
              }}</template>
            </el-table-column>
            <el-table-column label="操作" fixed="right">
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="
                    adjustPosition(scope.$index, scope.row)
                  "
                  type="text"
                  >岗位调整</el-button
                >
                <el-button
                  @click.native.prevent="setUpPosition(scope.$index, scope.row)"
                  type="text"
                  v-if="!scope.row.isMajor"
                  >设为主岗位</el-button
                >
                <el-button
                  @click.native.prevent="
                    deletePosition(scope.$index, tablePosts)
                  "
                  type="text"
                  class="del-btn"
                  v-if="!scope.row.isMajor"
                  >移除</el-button
                >
              </template>
            </el-table-column>
            <template slot="empty">当前岗位列表为空</template>
          </el-table>
        </div>
        <div class="basic-item">
          <div class="basic-item-title">社保信息</div>
          <div class="basic-item-main">
            <div class="main-item">
              <el-form-item label="工资卡号">
                <el-input
                  v-model="employe.cardNumber"
                  placeholder="请输入工资卡号"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="银行">
                <el-select
                  v-model="employe.cardBank"
                  clearable
                  placeholder="请选择银行"
                >
                  <el-option
                    v-for="item in cardBankOptions"
                    :key="item.option"
                    :label="item.option"
                    :value="item.option"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属城市">
                <el-input
                  v-model="employe.cardCity"
                  placeholder="请输入银行卡所属城市"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <div class="main-item basic-item-right">
              <el-form-item label="支行">
                <el-input
                  v-model="employe.cardBankName"
                  placeholder="请输入支行"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="是否参保">
                <el-radio-group v-model="employe.hasJoinedSocialInsurance">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- TODO:缺少社保账号/社保方案字段 -->
              <!-- <el-form-item label="社保账号" v-if="employe.hasJoinedSocialInsurance">
                <el-input v-model="employe.cardNumber" placeholder="请输入社保账号" clearable></el-input>
              </el-form-item>-->
              <!-- <el-form-item label="社保方案">
                <el-select v-model="employe.socialSecurity.scheme" clearable placeholder="请选择社保方案">
                  <el-option
                    v-for="item in socialSecurityScheme"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>-->
            </div>
          </div>
        </div>
        <div class="basic-item">
          <div class="basic-item-title">教育信息</div>
          <div class="basic-item-main">
            <div class="main-item">
              <el-form-item label="学历">
                <el-select
                  v-model="employe.educationType"
                  clearable
                  placeholder="请选择学历"
                >
                  <el-option
                    v-for="item in educationOptions"
                    :key="item.option"
                    :label="item.option"
                    :value="item.option"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="专业">
                <el-input
                  v-model="employe.profession"
                  placeholder="请输入专业"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <div class="main-item basic-item-right">
              <el-form-item label="毕业院校">
                <el-input
                  v-model="employe.college"
                  placeholder="请输入毕业院校"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="毕业时间">
                <el-date-picker
                  align="center"
                  v-model="employe.graduationTime"
                  type="date"
                  placeholder="请选择毕业时间"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="group-btn">
          <el-button
            type="primary"
            @click="createEmploye"
            :loading="submitLoading"
            >{{ submitText }}</el-button
          >
          <el-button @click="$router.go(-1)">取消</el-button>
        </div>
      </el-form>
      <el-dialog
        :title="positionEditTitle"
        :visible.sync="isPositionShow"
        width="680px"
        custom-class="employe-position"
        @close="handleClose('positionForm')"
      >
        <el-form
          :model="positionForm"
          label-position="left"
          label-width="5rem"
          :rules="createRules"
          ref="positionForm"
        >
          <el-form-item label="原岗位" v-if="originalPosition.grade"
            >{{ originalPosition.organization }}-{{
              originalPosition.grade[0]
            }}-{{ originalPosition.grade[1] }}</el-form-item
          >
          <el-form-item label="岗位" required>
            <div class="select-inline">
              <el-form-item prop="grade">
                <el-cascader
                  v-model="positionForm.grade"
                  :options="posts"
                  :props="positionProps"
                  placeholder="请选择职务职级"
                  filterable
                  clearable
                ></el-cascader>
              </el-form-item>
              <el-form-item prop="organization" class="tree-select">
                <treeselect
                  noOptionsText="未找到对应数据"
                  noResultsText="未找到对应数据"
                  v-model="positionForm.organization"
                  value-consists-of="BRANCH_PRIORITY"
                  :multiple="false"
                  :options="orgs"
                  :normalizer="normalizer"
                  :flatten-search-results="false"
                  :value="config"
                  placeholder="请选择部门"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item label="生效日期" prop="effectiveTime">
            <el-date-picker
              align="center"
              v-model="positionForm.effectiveTime"
              type="date"
              placeholder="请选择生效日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="备注" prop="more" class="auto-height">
            <el-input
              type="textarea"
              v-model="positionForm.more"
              maxlength="200"
              show-word-limit
              resize="none"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="isPositionShow = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('positionForm')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { deepCopy } from "@/utils/deepCopy";
import headerTop from "@/components/HeaderTop";
import {
  validatePhone,
  validateEmail,
  validateIdentityCard,
} from "@/utils/validate";
import { getPostAllTree } from "@/http/api/position";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { getOrgAllTree } from "@/http/api/organization";
import { createUser } from "@/http/api/employe";
import { getUserSettings, getIdentitySettings } from "@/http/api/system";
import { tree } from "@/utils/tree";
import { cityData } from "./city.js";

export default {
  components: {
    headerTop,
    Treeselect,
  },
  data() {
    const validatePassword = (rule, value, callback) => {
      let len = this.passwordOptions.length;
      if (!value) {
        callback();
      } else if (value.length < len) {
        callback(new Error(`密码最少${len}位数`));
      } else if (
        this.passwordOptions.requireLowercase &&
        !/[a-z]/.test(value)
      ) {
        callback(new Error(`密码应包含小写字母`));
      } else if (
        this.passwordOptions.requireUppercase &&
        !/[A-Z]/.test(value)
      ) {
        callback(new Error(`密码应包含大写字母`));
      } else if (this.passwordOptions.requireDigit && !/[0-9]/.test(value)) {
        callback(new Error(`密码应包含数字`));
      } else if (
        this.passwordOptions.requireNonAlphanumeric &&
        !/[^a-zA-Z0-9]/.test(value)
      ) {
        callback(new Error(`密码应包含非字母数字`));
      } else {
        callback();
      }
    };
    const validateIdentityCardNumber = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!validateIdentityCard(value)) {
        callback(new Error("身份证号输入不正确"));
      } else {
        callback();
      }
    };
    const validatePhoneNumber = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号"));
      } else if (!validatePhone(value)) {
        callback(new Error("手机号输入不正确"));
      } else {
        callback();
      }
    };
    const validateContactPhoneNumber = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!validatePhone(value)) {
        callback(new Error("手机号输入不正确"));
      } else {
        callback();
      }
    };
    const validateEmails = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!validateEmail(value)) {
        callback(new Error("邮箱输入不正确"));
      } else {
        callback();
      }
    };
    return {
      normalizer(node) {
        if (node.data && node.data.id) {
          return {
            id: node.data.id + " " + node.data.name,
            label: node.data.name,
            children: node.children,
          };
        }
      },
      submitLoading: false,
      fileList: [],
      config: ["disabled-checked"],
      submitText: "保存",
      uploadText: "上传头像",
      positionEditTitle: "", // 岗位异动窗口标题
      isPositionShow: false, // 岗位窗口显示
      positionIndex: 0, // 选定的岗位下标
      originalPosition: {}, // 岗位窗口中的原岗位
      positionProps: {
        expandTrigger: "hover",
      },
      positionForm: {
        grade: [],
        organization: null,
        effectiveTime: "",
        more: "",
        isMajor: false,
      }, // 岗位表单
      employeRules: {
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        phoneNumber: [
          { required: true, trigger: "blur", validator: validatePhoneNumber },
        ],
        password: [
          { required: false, trigger: "blur", validator: validatePassword },
        ],
        contactPhoneNumber: [
          {
            required: false,
            trigger: "blur",
            validator: validateContactPhoneNumber,
          },
        ],
        email: [
          { required: false, trigger: "blur", validator: validateEmails },
        ],
        workTime: [
          { required: true, message: "请选择入职时间", trigger: "change" },
        ],
        identityCard: [
          {
            required: false,
            trigger: "blur",
            validator: validateIdentityCardNumber,
          },
        ],
      },
      createRules: {
        grade: [
          { required: true, message: "请选择职务职级", trigger: "change" },
        ],
        organization: [
          { required: true, message: "请选择部门", trigger: "change" },
        ],
        effectiveTime: [
          { required: true, message: "请选择生效日期", trigger: "change" },
        ],
        more: [{ required: false }],
      }, // 创建岗位规则
      employe: {
        marriageStatus: "未婚",
        status: "probation",
        sex: "保密",
        hasPassedRegularWorkTest: false,
        hasJoinedSocialInsurance: false,
        tryWorkDays: "三个月",
        jobs: [],
      }, // 员工对象
      sexOptions: [], // 性别选项
      marriageOptions: [], // 婚姻选项
      educationOptions: [], // 教育背景
      politicalOptions: [], // 政治背景
      recruitWayOptions: [], // 招聘渠道
      cardBankOptions: [], // 社保绑定的银行
      nationOptions: [], // 民族选项
      teacherGradeOptions: [], // 带训师等级
      posts: [],
      tablePosts: [],
      orgs: [],
      passwordOptions: {
        length: "",
        requireLowercase: "",
        requireUppercase: "",
        requireDigit: "",
        requireNonAlphanumeric: "",
        user: "",
      },
      photoUrl: "",
      photoFile: {},
    };
  },
  computed: {
    tryWorkDaysLabel() {
      switch (this.employe.status) {
        case "probation":
          return "试用期限";
          break;
        case "recovery":
          return "复岗期限";
          break;
      }
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getUserSettings();
      this.getPosts();
      this.getOrgs();
      this.getIdentitySettings();
    },
    // 身份证失焦
    identityCardBlur(v) {
      if (validateIdentityCard(v)) {
        let value = v.slice(6, 14);
        value =
          value.slice(0, 4) + "-" + value.slice(4, 6) + "-" + value.slice(6, 8);
        this.employe.birthday = value;
        this.employe.sex = v[16] % 2 == 0 ? "女" : "男";
        cityData.map((el) => {
          if (el.code == v.substring(0, 6)) {
            this.employe.native = el.title;
          }
        });
      }
    },
    getFile(item) {
      this.photoFile = item.file;
    },
    // 获取密码配置
    getIdentitySettings() {
      getIdentitySettings().then((res) => {
        res.result.map((el) => {
          if (el.name == "Rocket.Identity.Password.RequiredLength") {
            this.passwordOptions.length = el.value;
          } else if (el.name == "Rocket.Identity.Password.RequireLowercase") {
            this.passwordOptions.requireLowercase = el.value;
          } else if (el.name == "Rocket.Identity.Password.RequireUppercase") {
            this.passwordOptions.requireUppercase = el.value;
          } else if (el.name == "Rocket.Identity.Password.RequireDigit") {
            this.passwordOptions.requireDigit = el.value;
          } else if (el.name == "Rocket.Identity.Password.User") {
            this.passwordOptions.user = el.value;
          } else if (
            el.name == "Rocket.Identity.Password.RequireNonAlphanumeric"
          ) {
            this.passwordOptions.requireNonAlphanumeric = el.value;
          }
        });
      });
    },
    // 获取用户配置字段
    getUserSettings() {
      getUserSettings().then((res) => {
        res.result.map((el) => {
          if (el.name == "Deer.User.Collection.Sex") {
            this.sexOptions = el.value;
          } else if (el.name == "Deer.User.Collection.MarriageStatus") {
            this.marriageOptions = el.value;
          } else if (el.name == "Deer.User.Collection.EducationType") {
            this.educationOptions = el.value;
          } else if (el.name == "Deer.User.Collection.Political") {
            this.politicalOptions = el.value;
          } else if (el.name == "Deer.User.Collection.RecruitWay") {
            this.recruitWayOptions = el.value;
          } else if (el.name == "Deer.User.Collection.CardBank") {
            this.cardBankOptions = el.value;
          } else if (el.name == "Deer.User.Collection.Nation") {
            this.nationOptions = el.value;
          } else if (el.name == "Deer.User.Collection.TrainingTeacherGrade") {
            this.teacherGradeOptions = el.value;
          }
        });
      });
    },
    // 获取职位
    getPosts() {
      getPostAllTree({ loadMode: 2 }).then((res) => {
        tree(res.result.items).map((item) => {
          this.posts.push({
            value: item.data.id + " " + item.data.name,
            label: item.data.name,
            children: item.children,
          });
        });
        this.posts.forEach((item) => {
          let arr = [];
          if (item.children) {
            item.children.map((i) => {
              arr.push({
                value: i.data.id + " " + i.data.name,
                label: i.data.name,
              });
            });
            item.children = arr;
          }
        });
      });
    },
    // 获取组织
    getOrgs() {
      getOrgAllTree({ loadMode: 2 }).then((res) => {
        this.orgs = tree(res.result.items);
      });
    },
    // 上传头像回调
    uploadChange(file) {
      this.photoUrl = file.url;
      this.uploadText = "更换头像";
    },
    // 添加岗位
    addPosition() {
      this.positionEditTitle = "添加新岗位";
      this.isPositionShow = true;
    },
    // 岗位异动确认回调
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let form = deepCopy(this.positionForm),
            post = form.grade[0].split(" "),
            position = form.grade[1].split(" "),
            org = form.organization.split(" ");
          this.positionForm.postId = post[0];
          this.positionForm.positionId = position[0];
          this.positionForm.organizationUnitId = org[0];
          this.positionForm.organization = org[1];
          this.positionForm.grade = [post[1], position[1]];
          if (this.originalPosition.grade) {
            // 调整岗位
            this.positionForm.isMajor = this.originalPosition.isMajor;
            this.tablePosts.splice(
              this.positionIndex,
              1,
              deepCopy(this.positionForm)
            );
            this.$message.success({ message: "调整成功", showClose: true });
          } else {
            // 添加岗位
            if (this.tablePosts.length) {
              this.positionForm.isMajor = false;
            } else {
              this.positionForm.isMajor = true;
            }
            this.tablePosts.push(deepCopy(this.positionForm));
            this.$message.success({ message: "添加成功", showClose: true });
          }
          this.isPositionShow = false;
          this.originalPosition = {};
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 关闭岗位窗口对调
    handleClose(formName) {
      this.$refs[formName].resetFields();
      this.originalPosition = {};
    },
    // 删除岗位
    deletePosition(index, rows) {
      this.$confirm(`是否移除该岗位？`, "移除岗位", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          rows.splice(index, 1);
          if (res.code == 10200) {
            this.$message.success({ message: "移除成功", showClose: true });
          }
        })
        .catch(() => {
          //console.log("已取消");
        });
    },
    // 调整岗位
    adjustPosition(index, v) {
      this.positionEditTitle = "岗位调整";
      this.isPositionShow = true;
      this.originalPosition = v;
      this.positionIndex = index;
    },
    // 设置主岗位
    setUpPosition(index, v) {
      this.$confirm(
        `是否将${v.organization}-${v.grade}设为主岗位？`,
        "设为主岗位提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      )
        .then(() => {
          this.tablePosts.forEach((el, i) => {
            if (i == index) {
              el.isMajor = true;
            } else {
              el.isMajor = false;
            }
          });
          // 主岗位放在首位
          if (index != 0) {
            this.tablePosts.unshift(this.tablePosts.splice(index, 1)[0]);
          }
        })
        .catch(() => {
          //console.log("已取消");
        });
    },
    // 确认添加员工
    createEmploye() {
      this.$refs.employeForm.validate((valid) => {
        if (valid) {
          if (this.tablePosts.length) {
            // 添加主岗位
            let post = deepCopy(this.tablePosts);
            post.map((el) => {
              delete el.grade;
              delete el.organization;
              return el;
            });
            this.employe.jobs = post;
          } else {
            this.$message.warning("岗位信息不能为空");
            return;
          }
          if (!this.employe.password) {
            this.employe.password = this.passwordOptions.user;
          }
          this.employe.userName = this.employe.phoneNumber;

          let employe = deepCopy(this.employe);

          if (employe.tryWorkDays == "三个月") {
            employe.tryWorkDays = 90;
          }
          if (employe.status == "nomail") {
            employe.tryWorkDays = 0;
          }
          this.submitLoading = true;
          this.submitText = "保存中";
          var formData = new FormData();
          formData.append("User", JSON.stringify(employe));
          if (JSON.stringify(this.photoFile) != "{}") {
            formData.append("PhotoFile", this.photoFile);
          }
          createUser(formData)
            .then((res) => {
              if (res.code == 10200) {
                this.$message.success({
                  message: "添加成功",
                  showClose: true,
                });
                this.submitLoading = false;
                this.submitText = "保存";
                this.$router.go(-1);
              }
            })
            .catch((err) => {
              this.submitLoading = false;
              this.submitText = "保存";
              if (err.error.code == "Identity.DuplicateUserName") {
                this.$message.error({
                  message: `手机号${this.employe.phoneNumber}已被占用`,
                  showClose: true,
                });
              }
            });
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.create-employe {
  background-color: #f2f2f2;

  .basic-info {
    margin: 20px;
  }

  .basic-info {
    background-color: #fff;
    padding: 20px;
    text-align: left;
    min-width: 960px;
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
    ::v-deep .el-date-editor {
      .el-input__inner {
        padding-left: 30px;
      }
      .el-icon-circle-close {
        right: 0;
      }
    }
    .basic-item {
      .post-symbol {
        color: #f56c6c;
      }
      .basic-item-title {
        margin-bottom: 20px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(0, 0, 0, 1);
      }

      .add-position {
        margin-bottom: 10px;
      }

      .basic-item-main {
        margin-bottom: 25px;
        padding-bottom: 15px;
        display: flex;
        border-bottom: 1px solid #ddd;

        .main-item {
          width: 50%;

          .el-select,
          .el-input,
          .el-date-editor {
            width: 330px;
          }

          .basic-head {
            .basic-head-item {
              display: flex;
              align-items: flex-end;
              margin-bottom: 8px;
              line-height: 0;

              .default-img,
              .basic-head-img {
                margin-right: 10px;
                width: 143px;
                height: 148px;
              }

              .upload-btn {
                border: 1px solid rgba(221, 221, 221, 1);
                width: 110px;
                height: 30px;
                font-size: 12px;
                font-weight: 400;
                color: rgba(0, 0, 0, 1);
              }
            }
          }

          // .job-num-box {
          //   display: flex;
          //   font-size: 12px;
          //   font-weight: 400;
          //   color: rgba(0, 0, 0, 1);
          //   vertical-align: middle;

          //   p {
          //     margin: 0;
          //   }

          //   .job-num-btn {
          //     margin-left: 10px;
          //     font-size: 12px;
          //     font-weight: 400;
          //     color: $--color-primary;
          //     cursor: pointer;
          //   }
          // }

          .account-lock {
            display: inline-block;
            margin-right: 5px;
          }

          .lock-svg {
            margin-top: -2px;
          }

          .work-age {
            display: flex;
            width: 330px;

            .el-input {
              width: 50%;
              &:first-child {
                ::v-deep .el-input-group__append {
                  border-right-color: transparent;
                }
              }
            }
          }

          ::v-deep .el-form-item__content {
            .el-input-group {
              vertical-align: baseline;
            }
          }
        }

        .basic-item-right {
          padding-left: 50px;
        }

        .main-item-flex {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
      }

      .el-table {
        margin-bottom: 25px;
        .table-empty {
          color: $--color-primary;
          cursor: pointer;
        }
        .grade-box {
          display: flex;
          align-items: center;

          .grade-main {
            margin-left: 9px;
            border: 1px solid $--color-primary;
            padding: 0 5px;

            font-size: 12px;
            font-weight: 400;
            line-height: 18px;

            color: $--color-primary;
          }
        }
      }
    }

    .group-btn {
      margin-top: -5px;
    }

    ::v-deep .employe-position {
      .el-dialog__header {
        padding: 25px 25px 20px 25px;
      }

      .el-dialog__body {
        padding: 0 25px;

        .vue-treeselect__input-container {
          height: 28px;
        }

        .tree-select {
          width: 300px;
        }

        .vue-treeselect__menu {
          width: 358px !important;
        }
      }

      .el-dialog__footer {
        padding: 15px 25px 25px 25px;
      }
    }
  }
}
</style>